$(document).ready(function() {
  $(window).scroll(function(){
    if($(window).scrollTop() > 0 ) {
      $("header").addClass('fixed');
    } else {
      $("header").removeClass('fixed');
    }
  });
  inView('.js-animate')
  .on('enter', el => {
      $(el).addClass("css-animate");
  });
  $(window).scroll(function(){
    if($(window).scrollTop() > 300 ) {
      $(".arrow-top").addClass('active');
    } else {
      $(".arrow-top").removeClass('active');
    }
  });
  $(".arrow-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  $('.banner__mouse').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.private').offset().top - 80
    }, 1500, 'swing');
  });
  $(".header__mobile_menu, .close_menu").click(function () {
    $(".mobileMenu").toggleClass("active");
  });
  $(".message__info").click(function(){
    $(".message__info").css("display", "none");
  });
  var owl = $('.banner__wrapper');
  owl.on('initialized.owl.carousel changed.owl.carousel', function(e) {
    if (!e.namespace)  {
      return;
    }
    var carousel = e.relatedTarget;
    $('.banner-counter span.actual').text('0' + (carousel.relative(carousel.current()) + 1) + '/');
    $('.banner-counter span.all').text('0' + carousel.items().length);
  });
  owl.owlCarousel({
    loop: true,
    margin: 0,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    dots: true,
    items: 1,
    mouseDrag: false,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 7000,
    onRefreshed:function(el){
      $('.banner__wrapper').find(".banner__item-text").removeClass("css-animation");
      $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text").addClass("css-animation");
    },
    onInitialized:function(el){

    },
    onChanged:function(el){
      setTimeout(function() {
        $('.banner__wrapper').find(".banner__item-text").removeClass("css-animation");
        $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text").addClass("css-animation");
      }, 1000);
    }
  });
  $(".banner__tiles_item").flip({
    axis: 'y',
    trigger: 'hover',
    reverse: true
  });
  $('.banner__nav_prev').click(function(){
    owl.trigger('prev.owl.carousel');
  });
  $('.banner__nav_next').click(function(){
      owl.trigger('next.owl.carousel');
  });
  $('.galleryHome__inner').owlCarousel({
    loop: true,
    margin: 50,
    navigation: false,
    autoWidth: true,
    center: true,
    dots: true,
    items: 2,
    mouseDrag: true,
    smartSpeed: 1500,
    autoplay: false,
    autoplayTimeout: 7000,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1,
        autoWidth: false,
      },
      1200: {
        items: 3
      }
    }
  });
  $('.video--slider-wrap').slick({
    prevArrow: $('.arrow--slider-prev'),
    nextArrow: $('.arrow--slider-next'),
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: false,
    swipe: true,
    vertical: true,
    dots: false,
    infinite: true
  });
  $('.offer__slider_wrapper')
  .slick({
      prevArrow: $('.offer__slider_prev'),
      nextArrow: $('.offer__slider_next'),
      autoplay: true,
      autoplaySpeed: 8000,
      dots: true,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      cssEase: 'linear'
  });
  $('.content__gallery').magnificPopup({
    delegate: 'a.openPhoto',
    type: 'image',
    tLoading: 'Ładowanie #%curr%...',
    mainClass: 'mfp-with-zoom',
    tClose: 'Zamknij',
    removalDelay: 400,
    gallery: {
        enabled: true,
        navigateByImgClick: true,
        tPrev: 'Poprzednie',
        tNext: 'Następne',
        preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
        tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
    },
    image: {
        tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
        titleSrc: function (item) {
            return item.el.attr('title');
        }
    }
  });
});

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
$('.video--slider-item').bind('click', function(e) {
    e.preventDefault();
    $('.v-left-area').html('<div id="video--inner" class="video--inner"></div>');
    var player;
    var videoData = $(this).data('videoid');
    player = new YT.Player('video--inner', {
        height: '100%',
        width: '100%',
        videoId: videoData,
        playerVars: {
            showinfo: 0,
            rel: 0
        },
        events: {
            'onReady': function(e) { /* e.target.playVideo(); */ }
        }
    });
});

function onYouTubeIframeAPIReady() {
    if ($('.video--slider-wrap').length > 0) {
        if ($('.video--slider-item').length > 0) {
            $('.video--slider-item').click();
        } else {
            $('.galleryVideo .videoSlider > a:not(.bx-clone)')[0].click();
        }
    }
}